'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign2 = require('./_internal/_assign');

var _assign3 = _interopRequireDefault(_assign2);

var _len2 = require('./_internal/_len');

var _len3 = _interopRequireDefault(_len2);

var _max2 = require('./_internal/_max');

var _max3 = _interopRequireDefault(_max2);

var _newArray2 = require('./_internal/_newArray');

var _newArray3 = _interopRequireDefault(_newArray2);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

var _fillBy = require('./fillBy');

var _fillBy2 = _interopRequireDefault(_fillBy);

var _identity = require('./identity');

var _identity2 = _interopRequireDefault(_identity);

var _iterate = require('./iterate');

var _iterate2 = _interopRequireDefault(_iterate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fillByIdentity = (0, _fillBy2.default)(_identity2.default); /**
                                                                 * Apply functions from an array to corresponding index in other array
                                                                 *
                                                                 * @module apply
                                                                 * @func
                                                                 * @since 1.11.0
                                                                 * @param {Array} fns
                                                                 * @param {Array} vals
                                                                 * @returns {function|array}
                                                                 * @example
                                                                 *
                                                                 *     const add1 = a => a + 1;
                                                                 *     const add2 = a => a + 2;
                                                                 *     apply([add1, add2], [0, 0]); //=> [1, 2];
                                                                 *     apply([add1])([1, 2, 3]); //=> [2, 2, 3];
                                                                 */

var getFnsArray = (0, _compose2.default)(fillByIdentity, _newArray3.default);

var internal = function internal(fns, vals) {
  var fnsLength = (0, _len3.default)(fns);
  var valsLength = (0, _len3.default)(vals);
  var length = (0, _max3.default)(fnsLength, valsLength);
  var funcs = (0, _assign3.default)(getFnsArray(length), fns);
  var values = (0, _assign3.default)((0, _newArray3.default)(length), vals);
  var applyAt = function applyAt(i) {
    return funcs[i](values[i]);
  };
  return (0, _iterate2.default)(applyAt, length);
};
var apply = (0, _define2.default)(internal);

exports.default = apply;